import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import {
  createOurValueRequest,
  getOurValues,
  removeOurValue,
  updateOurValueRequest,
} from "../../../../services/api/landing/ourValues/ourValuesApi";

const getLang = () =>
  localStorage.getItem("language") === "ar" ? "ar" : "en";

const toastMessages = {
  add: {
    en: "Value created successfully!",
    ar: "تم إنشاء القيمة بنجاح!",
  },
  addError: {
    en: "Failed to create value.",
    ar: "فشل في إنشاء القيمة.",
  },
  update: {
    en: "Value updated successfully!",
    ar: "تم تحديث القيمة بنجاح!",
  },
  updateError: {
    en: "Failed to update value.",
    ar: "فشل في تحديث القيمة.",
  },
  delete: {
    en: "Value deleted successfully!",
    ar: "تم حذف القيمة بنجاح!",
  },
  deleteError: {
    en: "Failed to delete value.",
    ar: "فشل في حذف القيمة.",
  },
};

export const fetchOurValues = createAsyncThunk(
  "ourValues/fetchOurValues",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getOurValues();
      return response.data.data;
    } catch (error) {
      return rejectWithValue("Failed to fetch Our Values");
    }
  },
);

export const createOurValue = createAsyncThunk(
  "ourValues/createOurValue",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await createOurValueRequest(formData);
      return response.data.data;
    } catch (error) {
      return rejectWithValue("Failed to create Our Value");
    }
  },
);

export const updateOurValue = createAsyncThunk(
  "ourValues/updateOurValue",
  async ({ id, formData }, { rejectWithValue }) => {
    try {
      const response = await updateOurValueRequest(id, formData);
      return response.data.data;
    } catch (error) {
      return rejectWithValue("Failed to update Our Value");
    }
  },
);

export const deleteOurValue = createAsyncThunk(
  "ourValues/deleteOurValue",
  async (valueId, { rejectWithValue }) => {
    try {
      await removeOurValue(valueId);
      return valueId;
    } catch (error) {
      return rejectWithValue("Failed to delete Our Value");
    }
  },
);

const ourValuesSlice = createSlice({
  name: "ourValues",
  initialState: {
    valuesData: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchOurValues.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchOurValues.fulfilled, (state, action) => {
        state.loading = false;
        state.valuesData = action.payload;
      })
      .addCase(fetchOurValues.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(createOurValue.fulfilled, (state, action) => {
        state.valuesData.push(action.payload);
        toast.success(toastMessages.add[getLang()]);
      })
      .addCase(createOurValue.rejected, (state, action) => {
        state.error = action.payload;
        toast.error(toastMessages.addError[getLang()]);
      })
      .addCase(updateOurValue.fulfilled, (state, action) => {
        const index = state.valuesData.findIndex(
          (value) => value.id === action.payload.id,
        );
        if (index !== -1) {
          state.valuesData[index] = action.payload;
        }
        toast.success(toastMessages.update[getLang()]);
      })
      .addCase(updateOurValue.rejected, (state, action) => {
        state.error = action.payload;
        toast.error(toastMessages.updateError[getLang()]);
      })
      .addCase(deleteOurValue.fulfilled, (state, action) => {
        state.valuesData = state.valuesData.filter(
          (value) => value.id !== action.payload,
        );
        toast.success(toastMessages.delete[getLang()]);
      })
      .addCase(deleteOurValue.rejected, (state, action) => {
        state.error = action.payload;
        toast.error(toastMessages.deleteError[getLang()]);
      });
  },
});

export default ourValuesSlice.reducer;
